import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import './Subscription.css';

const Subscription = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert('Por favor, ingresa tu correo electrónico.');
      return;
    }

    // Generar token reCAPTCHA al momento del envío (los tokens v3 expiran en ~2 min)
    let recaptchaToken = null;
    if (executeRecaptcha) {
      try {
        recaptchaToken = await executeRecaptcha('subscribe');
      } catch (error) {
        console.error('Error ejecutando reCAPTCHA:', error);
        alert('Error de reCAPTCHA, por favor intente nuevamente.');
        return;
      }
    } else {
      alert('reCAPTCHA no está listo. Recarga la página e intente nuevamente.');
      return;
    }

    setIsLoading(true);

    try {
      // Verificar si el correo electrónico ya está registrado
      const q = query(collection(db, 'Subscriptions'), where('email', '==', email.trim()));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        alert('Este correo electrónico ya está suscrito.');
        setIsLoading(false);
        return;
      }

      // Verificar reCAPTCHA usando la Cloud Function
      const verifyUrl = process.env.REACT_APP_VERIFY_RECAPTCHA_URL;
      if (!verifyUrl) {
        console.warn('REACT_APP_VERIFY_RECAPTCHA_URL no configurada');
      }
      const response = verifyUrl
        ? await fetch(verifyUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: recaptchaToken }),
          })
        : { ok: false };

      const result = response.ok ? await response.json() : { success: false };

      if (result.success) {
        const subscriptionData = {
          email: email.trim(),
          timestamp: new Date(),
          recaptchaToken,
          emailSent: false
        };

        await addDoc(collection(db, 'Subscriptions'), subscriptionData);
        console.log('Subscription successful:', { email: email.trim() });

        setEmail('');
        alert('¡Gracias por suscribirte! Revisa tu correo electrónico.');
      } else {
        alert('Error de verificación reCAPTCHA. Por favor, intente nuevamente.');
      }
    } catch (error) {
      console.error('Error al suscribirse:', error);
      alert('Hubo un error al suscribirse. Por favor, intente nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="subscription-form">
      <h2>Suscríbete</h2>
      <form onSubmit={handleSubscribe}>
        <div className="form-group">
          <label className="label" htmlFor="subscription-email">
            Promos, novedades y ofertas exclusivas en tu correo
          </label>
          <input
            type="email"
            placeholder="tu@email.com"
            id="subscription-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="subscription-input"
            disabled={isLoading}
          />
        </div>
        <button type="submit" className="subscription-button" disabled={isLoading}>
          {isLoading ? 'Enviando...' : '¡Quiero suscribirme!'}
        </button>
      </form>
    </div>
  );
};

export default Subscription;